import { useTranslations } from '@vocab/react';
import { Box, Loader } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import { useRef } from 'react';

import { LicenceEditor } from 'src/components/Licences/LicenceEditor';
import { LicencesList } from 'src/components/Licences/LicencesList';
import {
  EditorDrawer,
  EditorDrawerProvider,
} from 'src/ui/EditorDrawer/EditorDrawer';

import { useQueryLicences } from '../../../../components/Licences/hooks/useQueryLicences';

import translations from './Licence.vocab/index';

export const Licences = () => {
  const { t } = useTranslations(translations);
  const scrollRef = useRef<HTMLDivElement>(null);

  const { data, loading } = useQueryLicences();

  if (loading) return <Loader />;

  return (
    <EditorDrawerProvider name="licences">
      <Box
        ref={scrollRef}
        style={{ scrollMarginTop: vars.space.xxlarge }} // offset for the Stack wrapping this component
        data={{ automation: 'licences-section', testid: 'licence-card' }}
      >
        <LicencesList licences={data?.licences} shouldShowHeader />
      </Box>
      <EditorDrawer
        name="licences"
        title={t('Licences certifications')}
        onClose={() => {
          scrollRef.current?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'start',
          });
        }}
      >
        <LicenceEditor licences={data?.licences} shouldCloseDrawerOnExit />
      </EditorDrawer>
    </EditorDrawerProvider>
  );
};
